// Request-wide search (FOI response page): query bounds enforced by the server (400 otherwise);
// one definition for server, client and contracts in citadel-shared/redactionLimits.js
import { REQUEST_SEARCH_QUERY_LENGTH } from 'citadel-shared/redactionLimits.js'
const DUE_DATE_BUSINESS_DAYS = 30

const provinces = ['AB', 'BC', 'MB', 'NB', 'NL', 'NS', 'NT', 'NU', 'ON', 'PE', 'QC', 'SK', 'YT']

const usageTypes = ['ADDRESS', 'THIRD_PARTY', 'RESPONSE', 'SIGNATURE', 'RESPONSE_ATTACHMENT', 'CATEGORY']
const publicAccessUsageTypes = ['RESPONSE', 'RESPONSE_ATTACHMENT']
const activityTypes = [
  'NEW_REQUEST',
  'STATUS_CHANGE',
  'BILL_CREATED',
  'BILL_DRAFT_CREATED',
  'BILL_DRAFT_DELETED',
  'BILL_REJECTED',
  'BILL_PAID_ONLINE',
  'BILL_PAID_IN_PERSON',
  'BILL_REFUNDED',
  'BILL_CANCELLED',
  'MANUAL',
  'DUE_DATE_PAUSED',
  'DUE_DATE_UNPAUSED',
  'DUE_DATE_CHANGE',
  'DUE_DATE_UPDATED',
  'INTERNAL_SUMMARY_UPDATED',
  'RESPONSE_MESSAGE_UPDATED',
  'KEYWORDS_UPDATED',
  'APPLICANT_TYPE_UPDATED',
  'RESPONSE_FILE_UPLOADED',
  'RESPONSE_ATTACHMENT_UPLOADED',
  'RESPONSE_FILE_DELETED',
  'RESPONSE_ATTACHMENT_DELETED',
  'RESPONSE_LINK_RESENT',
  'VERSION_CREATED',
  'LETTER_DRAFT_CREATED',
  'LETTER_DRAFT_EDITED',
  'LETTER_DRAFT_STATUS_CHANGE',
  'LETTER_DRAFT_DELETED',
  'LETTER_ASSIGNED_USER_UPDATED',
  'FOI_ASSIGNED_USER_UPDATED',
  'COMMUNICATION_DRAFT_CREATED',
  'COMMUNICATION_DRAFT_EDITED',
  'COMMUNICATION_SENT',
  'COMMUNICATION_DRAFT_DELETED',
  'CATEGORY_FILES_ARCHIVED',
  'CATEGORY_FILES_RESTORED',
  'CATEGORY_FILES_MOVED'
]

const downloadFileListTypeMap = {
  pir: 'Property Information Request',
  foi: 'Freedom of Information Request'
}

const FOI_RESPONSE_TAB_QUERY_VALUES = {
  request: 'request',
  communications: 'communications',
  billing: 'billing',
  deduplicationAndRedaction: 'deduplicationAndRedaction',
  documentsAndResponse: 'documentsAndResponse',
  letters: 'letters'
}

export {
  provinces,
  usageTypes,
  publicAccessUsageTypes,
  activityTypes,
  downloadFileListTypeMap,
  FOI_RESPONSE_TAB_QUERY_VALUES,
  REQUEST_SEARCH_QUERY_LENGTH,
  DUE_DATE_BUSINESS_DAYS
}
